import type { User } from 'firebase/auth';
import Navigation from '../components/Navigation';
import ResumeMatchingTab from '../components/ResumeMatchingTab';

interface ResumeMatchingPageProps {
  user: User;
}

export default function ResumeMatchingPage({ user }: ResumeMatchingPageProps) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Navigation user={user} />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <ResumeMatchingTab user={user} />
      </main>
    </div>
  );
}
